<template>
  <!--  :size="option.attribute.size" -->
  <t-form :requiredMark="option.attribute.required" :labelAlign="option.attribute.labelAlign">
    <t-form-item class="my_number" :label="option.attribute.label" :style="setStyles">
      <t-input-number class="my_number_item" v-model="iptVal" :theme="option.attribute.theme" :max="option.attribute.max" :min="option.attribute.min"
        :placeholder="option.attribute.placeholder" :align="option.attribute.align" :style="setStyles" :status="message"
        :tips="tips" @change="checkValue($event)" @input="input" ref="inputNumber" />
    </t-form-item>
    <!-- <t-button @click="test()">确定</t-button> -->
  </t-form>
</template>

<script>
import {
  getDataJson,
  pollingRefresh,
  hasNonEmptyValues,
  hasProperty,
} from "@/utils/refresh-cpt-data";
export default {
  name: "cpt-number",
  props: {
    option: Object,
    refMap: Object,
    current: Object,
    components: Array,
  },
  computed: {
    setStyles() {
      return {
        // "--labelWidth":this.option.attribute.labelWidth + "px",
        "--width": this.current.cptWidth + "px",
        "--height": this.option.attribute.height + "px",
        "--indent": this.option.attribute.indent + "px",
        "--bgColor": this.option.attribute.bgColor,
        "--textColor": this.option.attribute.textColor,
        "--placholderColor": this.option.attribute.textPlaceholderColor,
        "--fontStyle": this.option.attribute.fontStyle,
        "--fontWeight": this.option.attribute.fontWeight,
        "--fontFamily": this.option.attribute.fontFamily,
        "--fontSize": this.option.attribute.fontSize + "px",
        "--borderSize": this.option.attribute.borderSize + "px",
        "--borderColor": this.option.attribute.borderColor,
        "--borderRadius": this.option.attribute.borderRadius + "px",
        "--lineType": this.option.attribute.lineType,

        "--incNumberborderSize": this.option.attribute.incNumberborderSize + "px",
        "--decNumberborderSize": this.option.attribute.decNumberborderSize + "px",
        "--incNumberborderColor": this.option.attribute.incNumberborderColor,
        "--decNumberborderColor": this.option.attribute.decNumberborderColor,
        "--decNumberborderRadius": this.option.attribute.decNumberborderRadius + "px",
        "--incNumberborderRadius": this.option.attribute.incNumberborderRadius + "px",
        "--incNumberlineType": this.option.attribute.incNumberlineType,
        "--decNumberlineType": this.option.attribute.decNumberlineType,
        "--incNumberColor": this.option.attribute.incNumberColor,
        "--decNumberColor": this.option.attribute.decNumberColor,
        "--incNumberBg": this.option.attribute.incNumberBg,
        "--decNumberBg": this.option.attribute.decNumberBg,

        "--incNumberActiveborderSize": this.option.attribute.incNumberActiveborderSize + "px",
        "--decNumberActiveborderSize": this.option.attribute.decNumberActiveborderSize + "px",
        "--incNumberActivborderColor": this.option.attribute.incNumberActivborderColor,
        "--decNumberActivborderColor": this.option.attribute.decNumberActivborderColor,
        "--incNumberActivborderRadius": this.option.attribute.incNumberActivborderRadius + "px",
        "--decNumberActivborderRadius": this.option.attribute.decNumberActivborderRadius + "px",
        "--incNumberActivlineType": this.option.attribute.incNumberActivlineType,
        "--decNumberActivlineType": this.option.attribute.decNumberActivlineType,
        "--incNumberActivColor": this.option.attribute.incNumberActivColor,
        "--decNumberActivColor": this.option.attribute.decNumberActivColor,
        "--incNumberActivBg": this.option.attribute.incNumberActivBg,
        "--decNumberActivBg": this.option.attribute.decNumberActivBg,
      };
    },
    dataReload() {
      return this.option.attribute.globalDataReload || [0]
    }
  },
  watch: {
    "current.cptShow"(val) {
      if (val && this.dataReload.includes(1)) {
        this.refreshCptData();
      }
    },
    "option.attribute.hideCompInTab"(val) {
      // 组合选项卡内显示时
      if (!val && this.dataReload.includes(1)) {
        this.refreshCptData();
      }
    }
  },
  data() {
    return {
      iptVal: "",
      newData: "",
      jsFunFlag: false,
      message: "default",
      tips: "",
      uuid: null,
    };
  },
  // watch: {
  //   "option.attribute": {
  //     handler() {
  //       this.processData(this.option.cptDataForm, this.newData, this.jsFunFlag);
  //     },
  //     deep: true,
  //   },
  // },
  mounted() {
    // 兼容
    let isFieldIsInput = this.option.attribute.hasOwnProperty('isInput')
    if(!isFieldIsInput) {
      this.option.attribute['isInput'] = true
    }


    if(!this.option.attribute['isInput']) {
      this.$refs.inputNumber.$el.querySelector('input').setAttribute('readonly', 'readonly');
    }
  },
  created() {
    this.uuid = require("uuid").v1();
    // 新增属性兼容旧代码
    const attr = this.option.attribute
    if (!attr.min) attr.min = 0
    if (!attr.max) attr.max = 1000

    if (!attr.globalDataReload) {
      attr.globalDataReload = [0]
    }
    if (this.dataReload.includes(0)) {
      this.refreshCptData();
    }
  },
  methods: {
    refreshCptData(cptDataForm = this.option.cptDataForm, paras) {
      pollingRefresh(this.uuid, cptDataForm, () =>
        this.loadData(cptDataForm, paras)
      );
    },
    loadData(cptDataForm, paras) {
      const that = this;
      getDataJson(cptDataForm, paras, (res) => {
        that.newData =
          cptDataForm.dataSource == "4" && hasProperty(res, "jsFunction")
            ? res.resStr
            : res; //相同数据集只调用一次接口原因
        that.jsFunFlag =
          cptDataForm.dataSource == "4" && hasProperty(res, "jsFunction")
            ? res.jsFunction
            : false; //相同数据集只调用一次接口原因
        that.processData(cptDataForm, that.newData, that.jsFunFlag);
      });
    },
    processData(cptDataForm, res, jsFunFlag, isFromGrid) {
      // 第一层判断 如果选择数据集
      if (cptDataForm.dataSource == "4") {
        if (this.current.cptOption.interaction.fatherGridId && isFromGrid != 'ninegrid') return

        // 第二层判断 ，如果没有配转换脚本
        if (jsFunFlag) {
          //判断此控件在九宫格里面就不请求数据
          // 没有全部配置映射字段
          if (hasNonEmptyValues(this.option.attribute.cptTableData)) {
            const dataKey = this.option.attribute.cptTableData;
            let newres = [];
            let newObj = { ...res[0] };
            newObj[dataKey[0].namekey] = newObj[dataKey[0].value];
            newres.push(newObj);
            this.iptVal = newres[0].value;
          }
        } else {
          // 如果配置了转换脚本
          this.iptVal = res.value;
        }
      } else {
        // 不是数据集类型，是静态数据
        this.iptVal = res.value;
      }
    },
    // 校验方法
    checkValue(event) {
      console.log('????');
      const isDesign = location.href.includes("/design"); //判断 是否是设计模式
      if(isDesign){
        return
      }
      const { attribute } = this.option;
      const int = /^$|^-?\d+$/;
      const zint = /^$|^[1-9]\d*$/;
      const fint = /^$|^-[1-9]\d*$/;
      const bigint = /^0|\d+$/;
      const smallint = /^-?\d+$/;
      const decimal = /^$|^-?\d+(\.\d+)?$/;
      console.log('qdijqwij9jqiwdjiqwijodwqjiod', this.iptVal, attribute.required, attribute.numbertype, zint.test(this.iptVal));

      if (attribute.required) {
        console.log(this.iptVal, 'this.iptVal')
        // 0 属于整数, 不属于正整数与负整数
        if (typeof this.iptVal === 'undefined' || this.iptVal === null || (typeof this.iptVal === 'string' && this.iptVal.trim() === '') && !(typeof this.iptVal === 'number' && this.iptVal === 0)) {
          this.setValidationMessage(false, `${attribute.label}必填`);
          return false;
        }
        if (attribute.numbertype == 'int' && !int.test(this.iptVal)) {
          this.setValidationMessage(false, `请输入整数`);
          return false;
        }
        if (attribute.numbertype == 'zint' && !zint.test(this.iptVal)) {
          this.iptVal = 0
          this.setValidationMessage(false, `请输入正整数`);
          return false;
        }
        if (attribute.numbertype == 'fint' && !fint.test(this.iptVal)) {
          this.setValidationMessage(false, `请输入负整数`);
          return false;
        }
        if (attribute.numbertype == 'bigint' && !bigint.test(this.iptVal)) {
          this.setValidationMessage(false, `请输入大于等于零整数`);
          return false;
        }
        if (attribute.numbertype == 'smallint' && !smallint.test(this.iptVal)) {
          this.setValidationMessage(false, `请输入小于等于零整数`);
          return false;
        }
        if (attribute.numbertype == 'decimal' && !decimal.test(this.iptVal)) {
          this.setValidationMessage(false, `请输入小数`);
          return false;
        }
      } else {
        if (this.iptVal) {
          if (attribute.numbertype == 'int' && !int.test(this.iptVal)) {
            this.setValidationMessage(false, `请输入整数`);
            return false;
          }
          if (attribute.numbertype == 'zint' && !zint.test(this.iptVal)) {
            this.iptVal = 0
            this.setValidationMessage(false, `请输入正整数`);
            return false;
          }
          if (attribute.numbertype == 'fint' && !fint.test(this.iptVal)) {
            this.setValidationMessage(false, `请输入负整数`);
            return false;
          }
          if (attribute.numbertype == 'bigint' && !bigint.test(this.iptVal)) {
            this.setValidationMessage(false, `请输入大于等于零整数`);
            return false;
          }
          if (attribute.numbertype == 'smallint' && !smallint.test(this.iptVal)) {
            this.setValidationMessage(false, `请输入小于等于零整数`);
            return false;
          }
          if (attribute.numbertype == 'decimal' && !decimal.test(this.iptVal)) {
            this.setValidationMessage(false, `请输入小数`);
            return false;
          }

        } else {
          if (this.iptVal != 0) {
            this.setValidationMessage(true);
            return true;
          }
        }
      }

      // 所有条件都通过后清除错误消息，并返回true
      this.setValidationMessage(true);
      if (this.option.attribute.cptFatherId) {
        let cptFind = this.components.find(item => item.id == this.option.attribute.cptFatherId)
        if (cptFind.cptType == 'ngcombination') {
          const dataKey = this.option.attribute.cptTableData[0];
          if (this.refMap[cptFind.id].tableData) {
            this.refMap[cptFind.id].tableData[this.option.interaction.gridNumber][dataKey.value] = this.iptVal
          }
          //  console.log(this.refMap[cptFind.id].tableData,'this.option.attribute.cptTableData')
          //  console.log(this.refMap[cptFind.id].tableData[this.option.interaction.gridNumber],'this.option.attribute.cptTableData333')
          //  console.log(dataKey,'this.option.attribute.cptTableData444')
        }
      }
      console.log('qwdkmqwodwqodod');
      // this.$emit("clickHandler", this.option.interaction, 'default', this.iptVal, 'cpt-number')
      this.$emit("clickHandler", this.option.interaction, {
          default: 'default',
          event: event,
          current: this.current,
        }, this.iptVal, 'cpt-number', '', this.current)
      return true;
    },
    setValidationMessage(isValid, errorMessage = "") {
      this.message = isValid ? "default" : "error";
      this.tips = isValid ? "" : errorMessage;
    },
    setValue(value) {
      this.iptVal = value
    },
    getValue() {
      return this.iptVal
    },
    input(e) {
      console.log('===')
      e.preventDefault();
      return false;
    }
    // test() {
    //   console.log(this.checkValue(),'-----')
    // }
  },
};
</script>

<style scoped>
.t-form :deep(.t-form__controls) {
  margin-left: 0px !important;
}

.my_number /deep/ .t-form__label {
  /* width:var(--labelWidth) !important; */
  color: var(--textColor);
  font-style: var(--fontStyle);
  font-weight: var(--fontWeight);
  font-family: var(--fontFamily);
  font-size: var(--fontSize);
  line-height: var(--height);
}

.my_number /deep/ .t-input-number {
  width: var(--width);
}

.my_number /deep/ .t-input {
  height: var(--height);
}

.my_number /deep/ .t-input-number .t-input-number__decrease,
.my_number /deep/ .t-input-number .t-input-number__increase {
  height: var(--height);
}

.my_number /deep/ .t-input-number.t-is-controls-right .t-input-number__decrease,
.my_number /deep/ .t-input-number.t-is-controls-right .t-input-number__increase {
  height: calc(calc(var(--height) / 2))
}

.my_number /deep/ .t-input-number.t-is-controls-right {
  width: var(--width);
}

.my_number_item /deep/ .t-input {
  background-color: var(--bgColor);
  border-width: var(--borderSize);
  border-color: var(--borderColor);
  border-radius: var(--borderRadius);
  border-style: var(--lineType);
}

.my_number_item /deep/ .t-input .t-input__inner {
  padding-left: var(--indent);
  color: var(--textColor);
  font-style: var(--fontStyle);
  font-weight: var(--fontWeight);
  font-family: var(--fontFamily);
  font-size: var(--fontSize);
}

.my_number_item /deep/ .t-input .t-input__inner::placeholder {
  color: var(--placholderColor);
}

.my_number_item /deep/.t-input:focus {
  box-shadow: none !important;
  border-color: var(--borderColor);
}

.my_number_item /deep/.t-input:hover {
  box-shadow: none !important;
  border-color: var(--borderColor);
}

.my_number_item /deep/.t-input--focused {
  box-shadow: none !important;
  border-color: var(--borderColor);
}

.my_number_item /deep/.t-is-focused {
  box-shadow: none !important;
  border-color: var(--borderColor);
}

.my_number /deep/ .t-input-number .t-input-number__decrease {
  background-color: var(--decNumberBg);
  border-width: var(--decNumberborderSize);
  border-color: var(--decNumberborderColor);
  border-radius: var(--decNumberborderRadius);
  border-style: var(--decNumberlineType);
}

.my_number /deep/ .t-input-number .t-input-number__increase {
  background-color: var(--incNumberBg);
  border-width: var(--incNumberborderSize);
  border-color: var(--incNumberborderColor);
  border-radius: var(--incNumberborderRadius);
  border-style: var(--incNumberlineType);
}

.my_number /deep/ .t-input-number .t-input-number__decrease .t-icon {
  color: var(--decNumberColor);
}

.my_number /deep/ .t-input-number .t-input-number__increase .t-icon {
  color: var(--incNumberColor);
}


.my_number /deep/ .t-input-number .t-input-number__decrease:active {
  background-color: var(--decNumberActivBg);
  border-width: var(--decNumberActiveborderSize);
  border-color: var(--decNumberActivborderColor);
  border-radius: var(--decNumberActivborderRadius);
  border-style: var(--decNumberActivlineType);
}

.my_number /deep/ .t-input-number .t-input-number__increase:active {
  background-color: var(--incNumberActivBg);
  border-width: var(--incNumberActiveborderSize);
  border-color: var(--incNumberActivborderColor);
  border-radius: var(--incNumberActivborderRadius);
  border-style: var(--incNumberActivlineType);
}

.my_number /deep/ .t-input-number .t-input-number__increase:hover {
  background-color: var(--incNumberActivBg);
  border-width: var(--incNumberActiveborderSize);
  border-color: var(--incNumberActivborderColor);
  border-radius: var(--incNumberActivborderRadius);
  border-style: var(--incNumberActivlineType);
}

.my_number /deep/ .t-input-number .t-input-number__decrease:hover {
  background-color: var(--decNumberActivBg);
  border-width: var(--decNumberActiveborderSize);
  border-color: var(--decNumberActivborderColor);
  border-radius: var(--decNumberActivborderRadius);
  border-style: var(--decNumberActivlineType);
}

.my_number /deep/ .t-input-number .t-input-number__decrease .t-icon:hover {
  color: var(--decNumberActivColor);
}

.my_number /deep/ .t-input-number .t-input-number__increase .t-icon:hover {
  color: var(--incNumberActivColor);
}

.my_number /deep/ .t-input-number .t-input-number__decrease .t-icon:active {
  color: var(--decNumberActivColor);
}

.my_number /deep/ .t-input-number .t-input-number__increase .t-icon:active {
  color: var(--incNumberActivColor);
}
</style>